import React from 'react';

import { useExhibitions } from '~/hooks/exhibitions';
import CompanyForm from '~/components/form/CompanyForm/index';
import styles from './create.module.scss';

const CreateFournisseur = () => {
  const { isLoading: isExhibitionsLoading } = useExhibitions();

  if (isExhibitionsLoading) {
    return <p>Loading</p>;
  }

  return (
    <div className={styles.create}>
      <CompanyForm companyType="fournisseur" />
    </div>
  );
};

export default CreateFournisseur;
